import { render, staticRenderFns } from "./VendorAmountInput.vue?vue&type=template&id=f3132f7c&scoped=true&"
import script from "./VendorAmountInput.vue?vue&type=script&lang=js&"
export * from "./VendorAmountInput.vue?vue&type=script&lang=js&"
import style0 from "./VendorAmountInput.vue?vue&type=style&index=0&id=f3132f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3132f7c",
  null
  
)

export default component.exports